/* @generated */

// src/assets/ui-icon/line/code.tsx
import * as React from "react";
var CodeLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m7.703 7.237-4.23 4.513 4.23 4.513 1.094-1.026-3.269-3.487 3.27-3.487-1.095-1.026Zm8.344 0-1.094 1.026 3.269 3.487-3.269 3.487 1.094 1.026 4.231-4.513-4.231-4.513ZM12.52 5.082l-3.001 13 1.461.337 3.001-13-1.461-.337Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CodeLine
};
